var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-container"},[_c('div',{staticClass:"uk-width-xxlarge uk-margin-auto uk-card uk-card-default"},[_c('table-enquiry')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }